
/***********************************************/

export function getDigits(param,num){
    return (("0000" + param).slice(-num).toString())
}

/***********************************************/

